<template>
  <v-layout column align-center class="canvas-nav-bar-container custom-scrollbar">
    <v-list class="canvas-nav-bar-list">
      <template v-for="(item, index) in navBarOptions">
        <v-divider
          v-if="item.isSmallDivider || item.isLargeDivider"
          :key="index"
          :class="item.isLargeDivider ? 'divider-large' : 'divider'"
        ></v-divider>

        <v-list-tile
          v-else
          :key="item.title"
          @click="$emit(item.action)"
          class="canvas-nav-bar-tile"
        >
          <v-list-tile-content>
            <v-tooltip right>
              <v-icon slot="activator" class="canvas-nav-bar-tile-icon material-symbols-outlined">{{ item.icon }}</v-icon>
              <span>{{ item.tooltip }}</span>
            </v-tooltip>
            <v-list-tile-title class="canvas-nav-bar-tile-title">
              <v-badge
                v-if="item.title === 'Save'"
                color="orange darken-3"
                overlap
                v-model="hasUnsavedChanges"
                class="uxl-badge uxl-badge-save"
              >
                <span slot="badge"></span>
                {{ item.title }}
              </v-badge>
              <span v-else>
                {{ item.title }}
                <img
                  v-if="item.title === 'AI'"
                  src="../../../static/2dsearch-ai/ai-icon.svg"
                  class="canvas-nav-bar-tile-title-img"
                  alt="AI icon"
                  draggable="false"
                />
              </span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </template>
    </v-list>
    <v-btn-toggle
      mandatory
      v-model="selectedView"
      class="layout-view-container"
      color="info"
    >
      <v-btn
        flat
        value="nested"
        :color="selectedView==='nested' ? 'primary' : ''"
        @click="$emit('handleViewClick', 'nested')"
      >
        <v-tooltip right>
          <span slot="activator">{{ $t('canvasNavBar.nestedLayout.title') }}</span>
          <span>{{ $t('canvasNavBar.nestedLayout.tooltip') }}</span>
        </v-tooltip>
      </v-btn>
      <v-btn
        flat
        value="inline"
        :color="selectedView==='inline' ? 'primary' : ''"
        @click="$emit('handleViewClick', 'inline')"
      >
        <v-tooltip right>
          <span slot="activator">{{ $t('canvasNavBar.inlineLayout.title') }}</span>
          <span>{{ $t('canvasNavBar.inlineLayout.tooltip') }}</span>
        </v-tooltip>
      </v-btn>
    </v-btn-toggle>
  </v-layout>
</template>

<script>
import '../../style/_variables.scss'

export default {
  name: 'canvas-nav-bar',
  props: ['hasUnsavedChanges'],
  data () {
    let navBarOptions = [
      {title: this.$t('canvasNavBar.ai.title'), icon: 'rebase_edit', tooltip: this.$t('misc.ai.title'), action: 'handleSearchAIClick'},
      {isLargeDivider: true},
      {title: this.$t('canvasNavBar.new.title'), icon: 'library_add', tooltip: this.$t('canvasNavBar.new.tooltip'), action: 'handleNewCanvasClick'},
      {title: this.$t('canvasNavBar.open.title'), icon: 'file_open', tooltip: this.$t('canvasNavBar.open.tooltip'), action: 'listQueries'},
      {isSmallDivider: true},
      {title: this.$t('canvasNavBar.save.title'), icon: 'save', tooltip: this.$t('canvasNavBar.save.tooltip'), action: 'handleSaveClick'},
      {title: this.$t('canvasNavBar.undo.title'), icon: 'undo', tooltip: this.$t('canvasNavBar.undo.tooltip'), action: 'handleUndoClick'},
      {title: this.$t('canvasNavBar.redo.title'), icon: 'redo', tooltip: this.$t('canvasNavBar.redo.tooltip'), action: 'handleRedoClick'},
      {title: this.$t('canvasNavBar.clear.title'), icon: 'deselect', tooltip: this.$t('canvasNavBar.clear.tooltip'), action: 'handleClearCanvas'},
      {isSmallDivider: true},
      {title: this.$t('canvasNavBar.add.title'), icon: 'addchart', tooltip: this.$t('canvasNavBar.add.tooltip'), action: 'handleImportClick'},
      {title: this.$t('canvasNavBar.upload.title'), icon: 'upload_file', tooltip: this.$t('canvasNavBar.upload.tooltip'), action: 'handleImportFileClick'},
      {isSmallDivider: true},
      {title: this.$t('canvasNavBar.treeLayout.title'), icon: 'account_tree', tooltip: this.$t('canvasNavBar.treeLayout.tooltip'), action: 'handleTreeViewClick'}
    ]
    return {
      navBarOptions: navBarOptions,
      selectedView: 'nested'
    }
  }
}
</script>
<style lang="scss" scoped>
.canvas-nav-bar {
  &-container {
    direction: rtl; // move scrollbar to left side
    background-color: $bg-primary;
    position: absolute;
    overflow-y: auto;
    overflow-x: hidden;
    height: calc(100vh - 122px - #{$main-header-height});
    width: $side-nav-width;
    z-index: 100;
    border-right: 5px solid $grey-400;
    border-radius: 0 0 40px 0;
  }
  &-list {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }
  &-tile {
    & > .list--dense {
      height: 50px;
    }
    &-title {
      text-align: center;
      font-size: 12px;
      &-img {
        position: absolute;
        top: 0;
        right: 18px;
      }
    }
  }
  &-tile-icon, &-tile-title {
    color: $black-900;
  }
  &-tile-icon {
    width: 60px;
    border-radius: 5px;
  }
}
.uxl-badge-save > .ababbadge__badge {
  right: 8px !important;
}
.layout-view {
  &-container {
    transform: rotate(-90deg);
    margin-top: 42px;
    box-shadow: unset;
    border: 1px solid black;
    border-radius: 15px;
  }
}
.btn--flat {
  background-color: unset;
}
.btn-toggle .btn:first-child {
  border-radius: 10px 0 0 10px;
}
.btn-toggle .btn:last-child {
  border-radius: 0 10px 10px 0;
}
.divider {
  width: 60%;
  min-height: 2px;
  background-color: $grey-500;
  margin: 5px 0;
  &-large {
    width: 75%;
    min-height: 3px;
    background-color: $blue-primary !important;
  }
}
.uxl-badge-save .badge__badge {
  right: -15px;
}
</style>



// WEBPACK FOOTER //
// src/components/parts/CanvasNavBar.vue